<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps,watchEffect } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Array,
    default: () => [],
  },
})
// console.log(props.leftData2);
const myEcharts = ref(null);

onMounted(() => {

  initChart(props.listData);
});


function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);


  let nameList = ["山东销往广东", "山东销往江苏", "山东销往浙江","山东销往四川", "山东销往湖南" ,"Top榜"]; // 类别
  let valueList = [36, 32, 38,36, 32, 38]; // 人数

  /* 数据整合 */
  let dataList = [];
  nameList.map((item, index) => {
    if (index === nameList.length-1) {
      dataList.push({
        name: item,
        value: valueList[index],
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: '#00C6FE' // 0% 处的颜色
            }, {
              offset: 1, color: '#0066F1' // 100% 处的颜色
            }],
            global: false // 缺省为 false
          },
        },
      })
    } else {
      dataList.push({
        name: item,
        value: valueList[index],
      })
    }
  })

  const option= {
    grid: {
      top: '8%',//上边距
      right: '1%',//右边距
      left: '0',//左边距
      bottom: "2%",//下边距
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: nameList,
      axisTick: {
        show: false //隐藏X轴刻度
      },
      axisLine: {
        lineStyle: {
          color: "#223967"
        }
      },
      axisLabel: {
        show: true,
        color: '#B6E6FF',
        fontSize: 22,
        lineHeight:30,
        interval:0,
        // rotate:15,
        formatter: function (params) {
          var str = "";                 // 最终拼接成的字符串
          var paramsLen = params.length;// 获取每项文字的个数
          var len = 3;                  // 每行能显示的字的个数（根据实际情况自己设置）
          var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
          if (paramsLen > len) {        //大于设定的len就换行，不大于就不变化
            for (var i = 0; i < rowNumber; i++) {
              var temp = "";            // 表示每一次截取的字符串
              var start = i * len;      // 开始截取的位置
              var end = start + len;    // 结束截取的位置
              if (i == rowNumber - 1) { // 最后一次不换行
                temp = params.substring(start, paramsLen);
              } else {                  // 每一次拼接字符串并换行
                temp = params.substring(start, end) + "\n";
              }
              str += temp;              // 最终拼成的字符串
            }
          } else {                      // 给新的字符串赋值
            str = params;
          }
          return str;                   //返回字符串
        }
      },
    },
    yAxis: [{
      boundaryGap: ['0', '20%'],
      type: 'value',
      name: "",
      splitNumber: 5,
      nameTextStyle: {
        color: '#B6E6FF',
        fontSize: 20,
        fontFamily: 'Source Han Sans CN-Regular',
        align: "left",
        verticalAlign: "center",
      },
      axisLabel: {
        fontSize: 22,
        color: '#fff',
        fontFamily: 'HarmonyOS Sans-Regular',
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: '#223967',
          type: "solid",
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        lineStyle: {
          color: '#223967',
          type: "solid",
        }
      }
    }],
    series: [{
      type: 'bar',
      data: dataList,
      itemStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#5EE401' // 0% 处的颜色
          }, {
            offset: 1, color: '#20A234' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
      },
      barWidth: 15,
    }]
  };// 将你的ECharts配置项放在这里
  chartInstance.setOption(option);

}
window.addEventListener("resize", () => {
  chartInstance.resize();
});
function splitArray(array, size) {
  var result = Array.from({ length: Math.ceil(array.length / size) }, function(_, index) {
    return array.slice(index * size, index * size + size);
  });
  return result;
}
</script>
<style lang="less"></style>
